import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { validateAndMapErrors } from 'common/utils/validate-and-map';
import makeChangesetReactive from 'common/utils/reactive-changeset';
import type {
  ProxyWrappedChangeset,
  ValidationFunction,
} from 'ember-form-changeset-validations';
import type {
  IntraFormChangeset,
  IntraFormDTO,
} from 'frontend/changesets/intra';
import type ActionModel from 'frontend/models/action';
import type ProductModel from 'frontend/models/product';
import type IntraFormChangesetService from 'frontend/services/changesets/intra-form';
import IntraFormValidation from 'frontend/validations/intra';
import { tracked } from 'tracked-built-ins';
import { TargetAudience } from 'common/enums/target-audience.enum';

interface FormationPartsIntraButtonComponentArgs {
  formation: ProductModel | ActionModel;
  type: 'action' | 'product';
}

export default class FormationPartsIntraButtonComponent extends Component<FormationPartsIntraButtonComponentArgs> {
  @service('changesets/intra-form')
  declare intraService: IntraFormChangesetService;
  @tracked declare intraChangeset: IntraFormChangeset;
  @tracked isOpenedModal = false;

  get isEnterpriseOrTeacher() {
    const target = this.args.formation.targetAudience;
    return (
      target === TargetAudience.Enterprise || target === TargetAudience.Teacher
    );
  }

  validationIntraForm: ValidationFunction<IntraFormDTO> = async (dto) =>
    validateAndMapErrors(IntraFormValidation, dto);

  @action
  async sendIntraForm(
    intraChangeset: ProxyWrappedChangeset<IntraFormChangeset>
  ) {
    this.intraChangeset.set('type', this.args.type);
    this.intraChangeset.set('title', this.args.formation.name);
    this.intraChangeset.set(
      'targetAudience',
      this.args.formation.targetAudience
    );
    await this.intraService.sendIntraForm(intraChangeset);
    this.toggleModal(false);
  }

  @action toggleModal(value?: boolean) {
    if (value) this.loadChangeset();
    this.isOpenedModal = value ?? !this.isOpenedModal;
  }

  loadChangeset() {
    this.intraChangeset = this.intraService.emptyChangeset();
    makeChangesetReactive(this, this.intraChangeset, IntraFormValidation);
  }
}
